import { ref } from 'vue';

// Shared notification state
const show = ref(false);
const message = ref('');
const type = ref('success'); // 'success' or 'error'
const timeout = ref(3000);
const closeable = ref(true); // Can user close the notification?

// Show notification function
export function showNotification(msg, notificationType = 'success', duration = 3000, isCloseable = true) {
  message.value = msg;
  type.value = notificationType;
  timeout.value = duration;
  closeable.value = isCloseable;
  show.value = true;
}

// Export reactive state
export const notificationStore = {
  show,
  message,
  type,
  timeout,
  closeable
};
